<div class="dialog-container">
  <h2 matDialogTitle class="visually-hidden">
    {{ "Columns-Settings" | translate }}
  </h2>
  <div class="header-wrapper">
    <span class="dark font-bold font-18"
      >{{ "Columns-Settings" | translate }}</span
    >
    <div class="icon-wrapper" matDialogClose>
      <i class="bi bi-x-lg"></i>
    </div>
  </div>
  <div
    class="content-wrapper"
    [dir]="currentLanguage === 'ar' ? 'rtl' : 'ltr' ">
    <div class="row mx-0">
      @for (header of headers; track header.key) {
      <!-- <div class="col-md-6 columns-wrapper">
        <nz-form-item>
          <label nz-checkbox [(nzChecked)]="header.isActive">
            <span
              nz-tooltip="{{ header.label | translate }}"
              [nzTooltipTitle]="header.label | translate">
              {{ header.label | translate }}
            </span>
          </label>
        </nz-form-item>
      </div> -->
      <div class="col-md-6 selection-box">
        <input
          type="checkbox"
          [id]="header.key"
          class="header-checkbox"
          [(ngModel)]="header.isActive" />
        <label
          [for]="header.key"
          pTooltip="{{
                    header.name | translate
                  }}"
          tooltipPosition="bottom"
          >{{ header.name | translate }}</label
        >
      </div>
      }
    </div>
  </div>
  <div class="footer-wrapper">
    <button class="default" matDialogClose>
      {{"Actions-List.Cancel"| translate }}
    </button>
    <button class="primary" (click)="saveHeaders()">
      {{ "Actions-List.Save" | translate }}
    </button>
  </div>
</div>
